@use '@/styles/tokens' as *;

// Header band carries both the title and the $0.00 lede (Figma 346:284029: band is 116px tall).
.header {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: 0 var(--space-6);
}

// Figma 346:284039 — Funnel Display 24 Regular, text/primary.
.title {
  margin: 0;
  font-size: $font-size-2xl;
  font-weight: $font-weight-regular;
}

// Figma 346:285084 — Geist 14 Regular with the amount run in SemiBold.
.lede {
  margin: 0;
  font-size: $font-size-md;
  font-weight: $font-weight-regular;
  color: $color-neutral-950;
}

.amount {
  font-weight: $font-weight-semibold;
}

.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: 0 var(--space-6);
}

// Figma 346:285085 — Geist 16 Regular.
.question {
  margin: 0;
  font-size: $font-size-lg;
  font-weight: $font-weight-regular;
  color: $color-neutral-950;
}

.choices {
  display: flex;
  // Figma 346:285099 — 14px gap; no 14px spacing token exists (4/8/12/16/…).
  gap: 14px;
}

// Figma 346:285094 — unselected card.
.choice {
  flex: 1;
  display: flex;
  flex-direction: column;
  // Figma 346:285095 — 6px title/description gap; no 6px spacing token exists.
  gap: 6px;
  padding: var(--space-3);
  text-align: left;
  background: var(--surface-card);
  border: 1px solid var(--border-default);
  border-radius: $radius-xl;
  cursor: pointer;

  // The repo applies the focus ring as a box-shadow (see action-menu / detail-drawer SCSS).
  &:focus-visible {
    box-shadow: var(--focus-ring);
  }
}

// Figma 346:285096 — selected card.
.choiceSelected {
  background: $color-accent1-50;
  border-color: $color-accent1-800;
}

.choiceTitle {
  font-size: $font-size-md;
  font-weight: $font-weight-medium;
  color: $color-neutral-950;
}

.choiceDescription {
  font-size: $font-size-xs;
  font-weight: $font-weight-regular;
  color: var(--text-tertiary);
}
